import React, { useRef, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { GoBold } from "react-icons/go";
import { BiItalic } from "react-icons/bi";
import { ImUnderline } from "react-icons/im";
import { RiArrowGoForwardFill, RiArrowGoBackFill } from "react-icons/ri";
import { IoMdColorFilter } from "react-icons/io";
import { BiBorderRadius } from "react-icons/bi";
//
import {
  AiOutlineAlignRight,
  AiOutlineAlignCenter,
  AiOutlineAlignLeft,
  AiOutlineColumnWidth,
  AiOutlineColumnHeight,
} from "react-icons/ai";
//
import { Color } from "../../../../Utils/styles";
import { randomBetweenToNumber } from "../../Function";
import CustomModal from "../Modal/CustomModal";
import { useOutsideHandle, useUploadImage } from "./Hooks";
import DropFile from "../DropFile";
import toast from "react-hot-toast";
import { el } from "date-fns/locale";
const EditorReact = ({ form, setForm }) => {
  const [step, setStep] = useState([
    {
      count: 1,
      form: {
        select: "p",
        values: [
          {
            tag: "p",
            id: 1,
            style: {},
            value:
              " اگر شما یک طراح هستین و یا با طراحی های گرافیکی سروکار دارید به متن های برخورده اید که با نام لورم ایپسوم شناخته می‌شوند. لورم ایپسوم یا طرح‌نما (به انگلیسی: Lorem ipsum) متنی ساختگی و <span style='color : red'>ارائه شکل کلی طرح استفاده می‌</span> بدون معنی است که برای امتحان فونت و یا پر کردن فضا در یک طراحی گرافیکی و یا صنعت چاپ استفاده میشود. طراحان وب و گرافیک از این متن برای پرکردن صفحه و کنند.",
          },
          {
            tag: "h2",
            id: 2,
            style: {},
            value:
              "اگر در ویرایشگر کدنویسی پلاگین ایمت (emmet) نصب شده است می‌توانید از آن برای تولید خودکار لورم ایپسوم برای پر کردن فضای متنی استفاده کنید",
          },
          {
            tag: "img",
            id: 3,
            style: {
              maxWidth: "100%",
              height: "auto",
            },
            alt: "salaladwadmwam",
            value:
              "http://192.168.100.19:8000/uploads/editor/d66496fbf509a5928dfa7b5030867698.jpg",
          },
        ],
        id: 1,
      },
    },
  ]);
  const [selected, setSelected] = useState({});
  const [change, setChange] = useState(false);
  const wrapperRef = useRef(null);
  useOutsideHandle(wrapperRef, () => {
    // setSelected({ status: false });
  });
  const convertObjToStyle = key => {
    switch (key) {
      case "maxWidth":
        return "max-width";
      case "backgroundColor":
        return "background-color";
      case "borderRadius":
        return "border-radius";
        break;
      case "textAlign":
        return "text-align";
      case "fontWeight":
        return "font-weight";
        break;
      default:
        break;
    }
  };
  const addStyle = style => {
    let res = "";
    Object.keys(style).map(key => {
      if (key) {
        res = res + `${convertObjToStyle(key)}:${style[key]};`;
      }
    });
    return res;
  };
  const renderNested = ({ start, end, style, value, allData, newValue }) => {
    return (
      `${allData.substring(0, start)}` +
      `<span style='${addStyle(style)}'>${value}</span>` +
      `${allData.substring(end, allData.length)} `
    );
  };

  const renderValue = (value, nesteds = []) => {
    let newValue = value;
    if (nesteds.length) {
      nesteds.map(nested => {
        newValue = renderNested({ ...nested, allData: value, newValue });
      });
    }

    return newValue;
  };

  const renderTag = () => {
    return form.values.map(({ tag, value, style, id, nested, alt }) => {
      // return (
      //   <div
      //     onClick={() => {
      //       setForm({ ...form, edit: id });
      //     }}
      //     dangerouslySetInnerHTML={{
      //       __html: renderValue(value, nested),
      //       // __html: value,
      //     }}
      //   ></div>
      // );
      switch (tag) {
        case "p":
          return (
            <p
              id={id}
              style={{ cursor: "pointer", ...style }}
              // onMouseUp={event => {
              //   const { anchorOffset, extentOffset, type } =
              //     window.getSelection();
              //   if (type == "Range") {
              //     setSelected({
              //       id,
              //       start: anchorOffset,
              //       end: extentOffset,
              //       status: true,
              //       pageX: event.pageX,
              //       pageY: event.pageY,
              //     });
              //   } else {
              //     setSelected({
              //       status: false,
              //     });
              //   }
              // }}
              onClick={() => {
                setForm({ ...form, edit: id });
              }}
              dangerouslySetInnerHTML={{
                __html: renderValue(value, nested),
                // __html: value,
              }}
            ></p>
          );
        case "link":
          return (
            <>
              <div
                id={id}
                style={{ cursor: "pointer", ...style }}
                // onMouseUp={event => {
                //   const { anchorOffset, extentOffset, type } =
                //     window.getSelection();
                //   if (type == "Range") {
                //     setSelected({
                //       id,
                //       start: anchorOffset,
                //       end: extentOffset,
                //       status: true,
                //       pageX: event.pageX,
                //       pageY: event.pageY,
                //     });
                //   } else {
                //     setSelected({
                //       status: false,
                //     });
                //   }
                // }}

                dangerouslySetInnerHTML={{
                  __html: value,
                  // __html: value,
                }}
              ></div>
              <button
                className="btn btn-success"
                onClick={() => {
                  setForm({ ...form, edit: id });
                }}
              >
                ویرایش ویدیو
              </button>
            </>
          );
        case "img":
          return (
            <img
              src={value}
              style={{ ...style, cursor: "pointer" }}
              onClick={() => {
                setForm({ ...form, edit: id });
              }}
              alt={alt || "سصس"}
            />
          );
        case "h1":
          return <h1 style={{ cursor: "pointer", ...style }}>{value}</h1>;
        case "h2":
          return (
            <h2
              onClick={() => {
                setForm({ ...form, edit: id });
              }}
              style={{ cursor: "pointer", ...style }}
            >
              {value}
            </h2>
          );

        case "h3":
          return (
            <h3
              onClick={() => {
                setForm({ ...form, edit: id });
              }}
              style={{ cursor: "pointer", ...style }}
            >
              {value}
            </h3>
          );
        case "h4":
          return (
            <h4
              onClick={() => {
                setForm({ ...form, edit: id });
              }}
              style={{ cursor: "pointer", ...style }}
            >
              {value}
            </h4>
          );
        case "h5":
          return (
            <h5
              onClick={() => {
                setForm({ ...form, edit: id });
              }}
              style={{ cursor: "pointer", ...style }}
            >
              {value}
            </h5>
          );
        case "h6":
          return (
            <h6
              onClick={() => {
                setForm({ ...form, edit: id });
              }}
              style={{ cursor: "pointer", ...style }}
            >
              {value}
            </h6>
          );
        default:
          break;
      }
    });
  };
  return (
    <div className="col-12" style={{ position: "relative" }}>
      <div>
        <div>
          <div
            style={{
              // position: "absolute",
              // bottom: selected.pageY,
              // top: selected.pageX,
              // zIndex: "9999",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Tools
              selected={selected}
              setSelected={setSelected}
              form={form}
              setForm={setForm}
            />
            <div className="d-flex justify-content-end">
              <button
                onClick={() => {
                  setForm({ ...form, modal: true });
                }}
                style={{
                  backgroundColor: Color.primary,
                  border: "none",
                  borderRadius: "50%",
                }}
              >
                <AiOutlinePlus color={Color.white} />
              </button>
            </div>
          </div>
        </div>
        <div
          style={{ height: "500px", position: "relative", overflowY: "scroll" }}
          className="border rounded mt-2 p-2"
          onClick={() => {}}
          ref={wrapperRef}
        >
          {renderTag()}
        </div>
      </div>
      {form.modal && (
        <CustomModal
          header={"اضافه کردن المان"}
          handleClose={() => {
            setForm({ ...form, modal: false });
          }}
          show={form.modal}
        >
          <Form form={form} setForm={setForm} step={step} setStep={setStep} />
        </CustomModal>
      )}
      {form.edit && (
        <CustomModal
          header={"ویرایش المان"}
          handleClose={() => {
            setForm({ ...form, edit: false });
          }}
          show={form.edit}
        >
          <Edit form={form} setForm={setForm} />
        </CustomModal>
      )}
    </div>
  );
};
const Form = ({ form, setForm, step, setStep }) => {
  const renderForm = () => {
    switch (form.kind) {
      case "link":
        return (
          <>
            <textarea
              className="form-control mt-2"
              placeholder="کد آی فریم آپارات"
              onChange={({ target: { value } }) => {
                setForm({ ...form, value });
              }}
              rows={10}
            ></textarea>
          </>
        );
      case "img":
        return <UploadImage form={form} setForm={setForm} />;
      case false:
        return <></>;
      case "imgTextLtr":
      case "imgTextRtl":
        return (
          <div className="d-flex justify-content-between">
            <div className="d-flex"></div>
            <div></div>
          </div>
        );
      default:
        return (
          <>
            <textarea
              className="form-control mt-2"
              placeholder="متن"
              onChange={({ target: { value } }) => {
                setForm({ ...form, value });
              }}
            ></textarea>
          </>
        );
        break;
    }
  };
  const takeCount = () => {
    if (step.length > 0) {
      return step[step.length].count;
    } else {
      return 1;
    }
  };
  const onClick = () => {
    if (form.kind == "img") {
      if (form.image) {
        if (form.alt) {
          uploadImg();
        } else {
          toast.error("متن جایگزین عکس را وارد کنید");
        }
      } else {
        toast.error("لطفا عکسی را انتخاب کنید");
      }
    } else {
      setStep([
        ...step,
        {
          // count: takeCount(),
          form: {
            ...form,
            values: [
              ...form.values,
              {
                tag: form.kind,
                currentValue: form.value,
                value: form.value,
                style: {},
                id: form.id,
                nested: [],
              },
            ],
            modal: false,
            id: form.id + 1,
          },
        },
      ]);
      setForm({
        ...form,
        values: [
          ...form.values,
          {
            tag: form.kind,
            currentValue: form.value,
            value: form.value,
            style: {},
            id: form.id,
            nested: [],
          },
        ],
        modal: false,
        id: form.id + 1,
      });
    }
  };
  const { uploadImg } = useUploadImage(form, setForm, step, setStep);
  return (
    <div>
      <div>
        <select
          className="form-select form-control"
          aria-label="Default select example"
          onChange={({ target: { value } }) => {
            setForm({ ...form, kind: value });
          }}
          defaultValue="p"
        >
          <option value={false} selected>
            نوع المان را انتخاب کنید
          </option>
          <option value={"p"}>پاراگراف (P)</option>
          <option value={"link"}>ویدیو آپارات</option>
          <option value={"h1"}>عنوان (h1)</option>
          <option value={"h2"}>عنوان (h2)</option>
          <option value={"h3"}>عنوان (h3)</option>
          <option value={"h4"}>عنوان (h4)</option>
          <option value={"h5"}>عنوان (h5)</option>
          <option value={"h6"}>عنوان (h6)</option>
          <option value={"img"}>عکس</option>
          <option value={"imgTextLtr"}>عکس با متن (چپ به راست)</option>
          <option value={"imgTextRtl"}>عکس با متن (راست به چپ)</option>
        </select>
      </div>
      <div>{renderForm()}</div>
      <div className="d-flex justify-content-end">
        <button className="btn btn-primary mt-2" onClick={onClick}>
          اضافه کردن
        </button>
      </div>
    </div>
  );
};

const Tools = ({ selected, setSelected, form, setForm }) => {
  const findElement = id => {
    return [...form.values]
      .map((element, count) => {
        if (element.id == id) {
          return { ...element, count };
        }
      })
      .filter(Boolean)[0];
  };
  const filterElement = id => {
    let arr = [...form.values]
      .map(element => {
        if (element.id != id) {
          return { ...element };
        }
      })
      .filter(Boolean);
    return arr;
  };
  const pushToArr = (index, obj, arr) => {
    return arr.splice(index, 0, obj);
  };
  const addStyle = (type, style = {}) => {
    if (selected.status && selected.id) {
      const { id, tag, value, nested, count } = findElement(selected.id);
      let newNes = [...nested];
      newNes.push({
        value: value.substring(selected.start, selected.end),
        style: { ...style },
        start: selected.start,
        end: selected.end,
      });

      const newValues = filterElement(selected.id);

      // const newState = pushToArr(
      //   count,
      //   { id, tag, value, nested: nested },
      //   newValues
      // );
      setForm({
        ...form,
        values: [...newValues, { id, tag, value, nested: newNes }],
      });
      // setStep([
      //   ...step,
      //   { ...form, values: [...newValues, { id, tag, value, nested: newNes }] },
      // ]);
    }
  };
  let elements = [
    {
      icon: () => {
        return <RiArrowGoBackFill />;
      },
      action: () => {
        // dawd
      },
      disiable: () => {
        return true;
      },
      style: {},
    },
    {
      icon: () => {
        return <RiArrowGoForwardFill />;
      },
      action: () => {
        // dawd
      },
      disiable: () => {
        return true;
      },
      style: {},
    },
  ];
  return (
    <div style={{ backgroundColor: Color.white }}>
      {elements.map(element => {
        {
          /* return (
          <button
            onClick={() => addStyle(element.type, element.style)}
            style={{
              backgroundColor: "transparent",
              border: "none",
              border: "1px solid #000",
            }}
            // disabled={!element.disiable()}
          >
            {element.icon()}
          </button>
        ); */
        }
      })}
    </div>
  );
};
const Edit = ({ form, setForm }) => {
  const element = findElement(form.edit, form);

  const [style, setStyle] = useState({ color: "#000" });
  if (element.tag == "img") {
    return (
      <div>
        <div className="row mb-2">
          <div className="col-md-4">
            <div className="input-group mt-2">
              <div className="input-group-prepend">
                <span className="input-group-text" id="basic-addon1">
                  <AiOutlineColumnWidth />
                </span>
              </div>
              <input
                type="number"
                className="form-control"
                placeholder="عرض (پیکسل)"
                aria-label="Username"
                aria-describedby="basic-addon1"
                min={120}
                defaultValue={element.style.width}
                onChange={({ target: { value } }) => {
                  setStyle({ ...style, width: `${value}px` });
                }}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="input-group mt-2">
              <div className="input-group-prepend">
                <span className="input-group-text" id="basic-addon1">
                  <AiOutlineColumnHeight />
                </span>
              </div>
              <input
                type="number"
                className="form-control"
                placeholder="ارتفاع (پیکسل)"
                aria-label="Username"
                aria-describedby="basic-addon1"
                min={120}
                defaultValue={element.style.height}
                onChange={({ target: { value } }) => {
                  setStyle({ ...style, height: `${value}px` });
                }}
              />
            </div>
          </div>{" "}
          <div className="col-md-4">
            <div className="input-group mt-2">
              <div className="input-group-prepend">
                <span className="input-group-text" id="basic-addon1">
                  <BiBorderRadius />
                </span>
              </div>
              <input
                type="number"
                className="form-control"
                placeholder="حاشیه (پیکسل)"
                aria-label="Username"
                aria-describedby="basic-addon1"
                min={1}
                defaultValue={element.style.borderRadius}
                onChange={({ target: { value } }) => {
                  setStyle({ ...style, borderRadius: `${value}px` });
                }}
              />
            </div>
          </div>
          {/*  */}
        </div>
        <img src={element.value} style={{ ...element.style, ...style }} />
        <textarea
          className="form-control mt-2"
          placeholder="متن جایگزین عکس (اجباری)"
          defaultValue={element.alt}
          rows={6}
          onChange={({ target: { value } }) => {
            setForm({ ...form, newAlt: value });
          }}
        ></textarea>
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-primary mr-2 mt-2"
            onClick={() => {
              setForm({
                ...form,
                values: filterElement(element.id, form),
                edit: false,
              });
            }}
          >
            حذف المان
          </button>
          <button
            onClick={() => {
              let newArr = filterElement(element.id, form);
              newArr.push({
                ...element,
                style: {
                  ...element.style,
                  ...style,
                },
                alt: form.newAlt ? form.newAlt : element.alt,
              });
              newArr = sortById(newArr);
              setForm({ ...form, values: newArr, edit: false });
            }}
            className="btn btn-success mt-2"
          >
            ثبت ویرایش
          </button>
        </div>
      </div>
    );
  } else if (element.tag == "link") {
    return (
      <>
        <textarea
          className="form-control mt-2"
          placeholder="متن"
          defaultValue={element.value}
          style={{ ...style }}
          rows={12}
          onChange={({ target: { value } }) => {
            setForm({ ...form, cycle: value });
          }}
        ></textarea>
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-primary mr-2 mt-2"
            onClick={() => {
              setForm({
                ...form,
                values: filterElement(element.id, form),
                edit: false,
              });
            }}
          >
            حذف المان
          </button>
          <button
            onClick={() => {
              let newArr = filterElement(element.id, form);
              newArr.push({
                ...element,
                value: form.cycle ? form.cycle : element.value,
                tag: form.newKind ? form.newKind : element.tag,
                style: {
                  ...element.style,
                  ...style,
                },
              });
              newArr = sortById(newArr);
              setForm({ ...form, values: newArr, edit: false });
            }}
            className="btn btn-success mt-2"
          >
            ثبت ویرایش
          </button>
        </div>
      </>
    );
  }
  return (
    <div>
      <div>
        <select
          className="form-select form-control mb-2"
          aria-label="Default select example"
          onChange={({ target: { value } }) => {
            setForm({ ...form, newKind: value });
          }}
          defaultValue={element.tag}
        >
          <option value={false} selected>
            نوع المان را انتخاب کنید
          </option>
          <option value={"p"}>پاراگراف (P)</option>
          <option value={"h1"}>عنوان (h1)</option>
          <option value={"h2"}>عنوان (h2)</option>
          <option value={"h3"}>عنوان (h3)</option>
          <option value={"h4"}>عنوان (h4)</option>
          <option value={"h5"}>عنوان (h5)</option>
          <option value={"h6"}>عنوان (h6)</option>
        </select>
      </div>
      <div className="d-flex align-items-center">
        {[
          {
            icon: () => {
              return <AiOutlineAlignRight />;
            },
            action: () => {
              // dawd
            },
            disiable: () => {},
            style: {
              textAlign: "right",
            },
          },
          {
            icon: () => {
              return <AiOutlineAlignCenter />;
            },
            action: () => {
              // dawd
            },
            disiable: () => {},
            style: {
              textAlign: "center",
            },
          },
          {
            icon: () => {
              return <AiOutlineAlignLeft />;
            },
            action: () => {
              // dawd
            },
            disiable: () => {},
            style: {
              textAlign: "left",
            },
          },
          {
            icon: () => {
              return <IoMdColorFilter />;
            },
            action: () => {
              // dawd
            },
            disiable: () => {},
            style: {
              textAlign: "left",
            },
            type: "color",
          },
        ].map(btn => {
          if (btn.type == "color") {
            return (
              <input
                type="color"
                // value={style.color}
                onChange={e => {
                  setStyle({ ...style, color: e.target.value });
                }}
              />
            );
          } else {
            return (
              <>
                <button
                  onClick={() => {
                    setStyle({ ...style, ...btn.style });
                  }}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    border: "1px solid #000",
                  }}
                  // disabled={!element.disiable()}
                >
                  {btn.icon()}
                </button>
              </>
            );
          }
        })}
      </div>

      <textarea
        className="form-control mt-2"
        placeholder="متن"
        defaultValue={element.value}
        style={{ ...style }}
        rows={12}
        onChange={({ target: { value } }) => {
          setForm({ ...form, cycle: value });
        }}
      ></textarea>

      <div id="accordion" className="mt-2">
        <div className="card">
          <div className="card-header" id="headingOne">
            <h5 className="mb-0">
              <button
                className="btn btn-link"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                انتخاب جزئی
              </button>
            </h5>
          </div>
          <div
            id="collapseOne"
            className="collapse"
            aria-labelledby="headingOne"
            data-parent="#accordion"
          >
            <div className="card-body">
              <MultiSelect form={form} setForm={setForm} element={element} />
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <button
          className="btn btn-primary mr-2 mt-2"
          onClick={() => {
            setForm({
              ...form,
              values: filterElement(element.id, form),
              edit: false,
            });
          }}
        >
          حذف المان
        </button>
        <button
          onClick={() => {
            let newArr = filterElement(element.id, form);
            newArr.push({
              ...element,
              value: form.cycle ? form.cycle : element.value,
              tag: form.newKind ? form.newKind : element.tag,
              style: {
                ...element.style,
                ...style,
              },
            });
            newArr = sortById(newArr);
            setForm({ ...form, values: newArr, edit: false });
          }}
          className="btn btn-success mt-2"
        >
          ثبت ویرایش
        </button>
      </div>
    </div>
  );
};
const UploadImage = ({ form, setForm }) => {
  return (
    <div className={`my-2 col`}>
      <DropFile
        images={form["image"]}
        set={e => {
          setForm({ ...form, image: e });
        }}
      />
      <textarea
        className="form-control"
        placeholder="متن جایگزین عکس (اجباری)"
        // defaultValue={element.value}
        // style={{ ...style }}
        rows={6}
        onChange={({ target: { value } }) => {
          setForm({ ...form, alt: value });
        }}
      ></textarea>
      <div className="row">
        <div className="col-md-4">
          <div className="input-group mt-2">
            <div className="input-group-prepend">
              <span className="input-group-text" id="basic-addon1">
                <AiOutlineColumnWidth />
              </span>
            </div>
            <input
              type="number"
              className="form-control"
              placeholder="عرض (پیکسل)"
              aria-label="Username"
              aria-describedby="basic-addon1"
              min={120}
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="input-group mt-2">
            <div className="input-group-prepend">
              <span className="input-group-text" id="basic-addon1">
                <AiOutlineColumnHeight />
              </span>
            </div>
            <input
              type="number"
              className="form-control"
              placeholder="ارتفاع (پیکسل)"
              aria-label="Username"
              aria-describedby="basic-addon1"
              min={120}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default EditorReact;
const MultiSelect = ({ form, setForm, element }) => {
  const [selected, setSelected] = useState({});

  const addStyle = (styleNes = {}) => {
    if (selected.status && selected.id) {
      const { id, tag, value, nested, count, style } = findElement(
        selected.id,
        form
      );
      let newNes = [...nested];
      newNes.push({
        value: value.substring(selected.start, selected.end),
        style: { ...styleNes },
        start: selected.start,
        end: selected.end,
      });

      const newValues = filterElement(selected.id, form);

      // const newState = pushToArr(
      //   count,
      //   { id, tag, value, nested: nested },
      //   newValues
      // );
      setForm({
        ...form,
        values: sortById([
          ...newValues,
          { id, tag, value, nested: newNes, style },
        ]),
      });
      // setStep([
      //   ...step,
      //   { ...form, values: [...newValues, { id, tag, value, nested: newNes }] },
      // ]);
    }
  };
  return (
    <>
      <div className="mb-2">
        <button
          onClick={() => {
            addStyle({ fontWeight: "bold" });
          }}
          style={{
            backgroundColor: "transparent",
            border: "none",
            border: "1px solid #000",
          }}
        >
          <GoBold />
        </button>
        <button
          onClick={() => {
            addStyle({ fontStyle: "italic" });
          }}
          style={{
            backgroundColor: "transparent",
            border: "none",
            border: "1px solid #000",
          }}
        >
          <BiItalic />
        </button>
        <button
          onClick={() => {
            addStyle({ fontWeight: "bold" });
          }}
          style={{
            backgroundColor: "transparent",
            border: "none",
            border: "1px solid #000",
          }}
        >
          <BiItalic />
        </button>
        <button
          onClick={() => {
            addStyle({ fontWeight: "bold" });
          }}
          style={{
            backgroundColor: "transparent",
            border: "none",
            border: "1px solid #000",
          }}
        >
          <ImUnderline />
        </button>
      </div>

      <p
        onMouseUp={event => {
          const { anchorOffset, extentOffset, type } = window.getSelection();
          if (type == "Range") {
            setSelected({
              id: element.id,
              start: anchorOffset,
              end: extentOffset,
              status: true,
              pageX: event.pageX,
              pageY: event.pageY,
            });
          } else {
            setSelected({
              status: false,
            });
          }
        }}
        dangerouslySetInnerHTML={{
          __html: element.value,
          // __html: value,
        }}
      ></p>
    </>
  );
};
const findElement = (id, form) => {
  return [...form.values]
    .map((element, count) => {
      if (element.id == id) {
        return { ...element, count };
      }
    })
    .filter(Boolean)[0];
};
const sortById = arr => {
  return arr.sort((a, b) => a.id - b.id);
};
const filterElement = (id, form) => {
  let arr = [...form.values]
    .map(element => {
      if (element.id != id) {
        return { ...element };
      }
    })
    .filter(Boolean);
  return arr;
};
const addStep = ({}) => {};
const changeStep = ({}) => {};
